import { useContext } from "react";

import { css } from "@emotion/react";

import { FilterOutlineIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import TableContext from "context/table/tableContext";
import { RectangleLoader } from "shared";

import { useFilterButton } from "./hooks";
import { FilterButtonProps } from "./types";

const FilterButton = ({
    children,
    onOpen,
    isDisabled,
    customLoadingWidth,
    customMobileLoaderStyle
}: FilterButtonProps) => {
    const { isInitialLoading } = useContext(TableContext);

    const { isIconOnly, getLeftMargin, getRightMargin, getRectangularWidth } =
        useFilterButton(customLoadingWidth);

    return isInitialLoading ? (
        <div
            css={css({
                height: "36px",
                display: "flex",
                alignItems: "center",

                "@media(max-width: 599px)": {
                    marginTop: "8px",
                    ...customMobileLoaderStyle
                }
            })}
        >
            <RectangleLoader
                width={getRectangularWidth()}
                height={24}
                customStyle={{
                    marginLeft: getLeftMargin(),
                    marginRight: getRightMargin()
                }}
            />
        </div>
    ) : (
        <Button
            color={BUTTON_COLORS.White}
            size={BUTTON_SIZES.Small}
            variant={
                isIconOnly ? BUTTON_VARIANTS.IconOnly : BUTTON_VARIANTS.IconLeft
            }
            icon={<FilterOutlineIcon />}
            disabled={isDisabled}
            onClick={onOpen}
            css={css({
                "@media(max-width: 599px)": {
                    marginTop: "8px"
                }
            })}
        >
            {children}
        </Button>
    );
};

export default FilterButton;
